import React from 'react';

const ContractorPortalFinance = () => {
    return (
        <div>

        </div>
    );
};

export default ContractorPortalFinance;